module.exports = __webpack_public_path__ + "img/karina.48b5227b.jpeg";